import { Action } from 'adaptivecards';
import { INVOKE_ADDIN_COMMAND } from '../utils/adaptiveCardActionTypes';

export default class InvokeAddinCommandAction extends Action {
    public addinId: string;
    public desktopCommandId: string;
    public initializationContext: string;

    constructor() {
        super();
        this.addinId = '';
        this.desktopCommandId = '';
        this.initializationContext = '';
    }

    parse(json: any) {
        super.parse(json);
        this.isPrimary = json.isPrimary;
        this.addinId = json.addInId ? json.addInId : json.addinid;
        this.desktopCommandId = json.desktopCommandId
            ? json.desktopCommandId
            : json.desktopcommandid;
        this.initializationContext = json.initializationContext
            ? JSON.stringify(json.initializationContext)
            : JSON.stringify(json.initializationcontext);
    }

    getJsonTypeName(): string {
        return INVOKE_ADDIN_COMMAND;
    }
}
